import { Injectable } from '@angular/core';
import { Pageable } from '@nimmsta/ng-commons-lib/models';
import {
  SFSOptions,
  WorkflowDataService,
} from '@nimmsta/ng-commons-lib/data-access';
import { Observable, map } from 'rxjs';
import { WorkflowEvent } from '../models/workflowEvent';

@Injectable({
  providedIn: 'root',
})
export class WorkflowEventService extends WorkflowDataService<WorkflowEvent> {
  private _currentWorkflowExecutionId!: string;

  protected override get apiEndpoint(): string {
    return '/workflow-execution';
  }

  public get currentWorkflowExecutionId() : string {
    return this._currentWorkflowExecutionId;
  }

  public set currentWorkflowExecutionId(id : string) {
    this._currentWorkflowExecutionId = id;
  }

  override list(options: Partial<SFSOptions> = {}): Observable<Pageable<WorkflowEvent>> {
    options.sortColumn = 'eventDate';
    options.sortOrder = 'desc';
    const params = this.getParams(options);
    return this.http.get<Pageable<WorkflowEvent>>(
      `${this.baseUrl + this.apiEndpoint}/${this.currentWorkflowExecutionId}/events`,
      {
        params,
      },
    ).pipe(map((page) => {
      page.content = page.content.map((item) => this.loadedDataTransform(item));
      return page;
    }));
  }
}
